import { Button as MaterialButton, ButtonProps as muiBprops } from "@material-ui/core";
import React from "react";
import { NavLink } from "react-router-dom";

export interface ButtonPros extends muiBprops {}

export function Button({ children, ...props }: ButtonPros) {
  return (
    <MaterialButton
      css={`
        .MuiButton-root {
          width: 189px;
          height: 49px;
          border-radius: 4px;
          box-shadow: 4px 2px 9px 0 rgba(0, 0, 0, 0.23);
          background-color: #399ebf;
        }
      `}
      {...props}
    >
      {children}
    </MaterialButton>
  );
}

export const ButtonLink = (props: any) => <Button component={NavLink} {...props} />;
